import { Alert, Button, Checkbox, Form, Icon, Input} from 'antd';
import { FormComponentProps } from "antd/lib/form";
import * as React from 'react';
import { IToolshedUser, postLogin } from "../apis/Auth";

// Rename Form.Item to FormItem so we can use it more easily
const FormItem = Form.Item;

// Define a new interface that inherits from the default FormComponentProps.
// We're adding a definition for our onLogin callback so that we can pass
// data back into the parent component
interface ILoginProps extends FormComponentProps {
    onLogin: (authorized: boolean, token: string) => void
}

// Define our local state in the way typescript needs
interface ILoginState {
  errorMessage: string | null,
}

class LoginForm extends React.Component<ILoginProps, ILoginState> {
  public constructor(props: any) {
      super(props);

      // Set the initial local state
      this.state = {
        errorMessage: null,
      }
  }

  public render() {
    // Much of this code comes verbatim from https://ant.design/components/form/
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        {this.state.errorMessage &&
          // Only display an error if an error message has been set
          <Alert message={ this.state.errorMessage } type="error" />
        }
        <FormItem>
          <label>Please type in your Toolshed credentials to proceed.</label>
        </FormItem>
        <FormItem>
          {getFieldDecorator('username', {
              rules: [{ required: true, message: 'Please input your username!' }],
          })(
              <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Please input your Password!' }],
          })(
              <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('remember', {
              initialValue: true,
              valuePropName: 'checked',
          })(
            <Checkbox>Remember me</Checkbox>
          )}
          <Button type="primary" htmlType="submit" className="login-form-button">
            Log in
          </Button>
        </FormItem>
      </Form>
    );
}
    private handleSubmit = (e: any) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
              // Make API call via apis/Auth
              postLogin(values.username, values.password).then((result) => {
                // If API call is successful, modify login state and redirect
                // a successful api call here requires a user in the result
                if (result.authorized) {
                  this.props.onLogin(result.authorized, result.authToken);
                } else {
                  this.setState({
                    errorMessage: result.error.message
                  });
                }
              });
            }
        });
    }
}

const WrappedLoginForm = Form.create()(LoginForm);

export default WrappedLoginForm;
